import utils from "@bigcommerce/stencil-utils";
import haloAddOptionForProduct from "../halothemes/haloAddOptionForProduct";

export default function (context) {
  let loadTabBar = true,
    check_carouselBannerReviewCustomer = true,
    check_ProductWithCateInterior = true,
    check_ProductWithCateExterior = true,
    check_ProductWithCatePerformance = true,
    check_ProductWithCate = true,
    check_BlockBannerBelowDevice = true,
    check_BlockBannerTopCategory = true,
    check_BlockBannerProductWithBanner = true,
    check_Automotive_slick = true;
  function build() {
    loadSlickAutomotiveBlock();
    window.addEventListener("scroll", (e) => {
      const $target = $(e.currentTarget);
      const tScroll = $target.scrollTop();
      loadFunction(tScroll);
    });

    function loadFunction (tScroll){
      loadTabBarFunction(tScroll);
      createCarouselBannerReviewCustomer(tScroll);
      loadSlickBlockBannerBelowAutomotive(tScroll);
      loadSlickBlockBannerTopCategory(tScroll);
      loadSlickBlockBannerProductWithBanner(tScroll);
      addLinkBanner();

      let slideProductWithCate =
        context.themeSettings["homeProd_with_cate"];
        slideProductWithCate = Number(slideProductWithCate);

      // Most Popular
      let selectorMostPopular = ".block-with-categories.most-popular";
      if(check_ProductWithCate){
        check_ProductWithCate = false;
      activeTabBlockWithCate(selectorMostPopular, slideProductWithCate);
      }
      // Cate with product 1
      let selectorCateWithProduct1 =
        "#cate-with-product-" +
        context.themeSettings["cate-with-product-idCate1"];
      const $selectorCateWithProduct1 = $(selectorCateWithProduct1);
      if ($selectorCateWithProduct1.length) {
        const $selectorCateWithProduct1Top =
          $selectorCateWithProduct1.offset().top - screen.height - 200;
        if (
          tScroll > $selectorCateWithProduct1Top &&
          check_ProductWithCateInterior
        ) {
          check_ProductWithCateInterior = false;
          activeTabBlockWithCate(
            selectorCateWithProduct1,
            slideProductWithCate - 1
          );
        }
      }
      // Cate with product 2
      let selectorCateWithProduct2 =
        "#cate-with-product-" +
        context.themeSettings["cate-with-product-idCate2"];
      const $selectorCateWithProduct2 = $(selectorCateWithProduct2);
      if ($selectorCateWithProduct2.length) {
        const $selectorCateWithProduct2Top =
          $selectorCateWithProduct2.offset().top - screen.height - 200;
        if (
          tScroll > $selectorCateWithProduct2Top &&
          check_ProductWithCateExterior
        ) {
          check_ProductWithCateExterior = false;
          activeTabBlockWithCate(
            selectorCateWithProduct2,
            slideProductWithCate - 1
          );
        }
      }
      // Cate with product 3

      let selectorCateWithProduct3 =
        "#cate-with-product-" +
        context.themeSettings["cate-with-product-idCate3"];
      const $selectorCateWithProduct3 = $(selectorCateWithProduct3);
      if ($selectorCateWithProduct3.length) {
        const $selectorCateWithProduct3Top =
          $selectorCateWithProduct3.offset().top - screen.height - 200;
        if (
          tScroll > $selectorCateWithProduct3Top &&
          check_ProductWithCatePerformance
        ) {
          check_ProductWithCatePerformance = false;
          activeTabBlockWithCate(
            selectorCateWithProduct3,
            slideProductWithCate - 1
          );
        }
      }
    }
    function loadSlickAutomotiveBlock (){

      let selector = ".block-automotive-device .container";
      const $blockAutomotive = $(selector);
      if(screen.width <=1024){
      if(check_Automotive_slick){
        check_Automotive_slick = false;
        if ($blockAutomotive.length) {
            $blockAutomotive.slick({
              dots: false,
              arrows: true,
              infinite: true,
              mobileFirst: true,
              slidesToShow: 2,
              slidesToScroll: 2,
              responsive: [
                {
                  breakpoint: 1025,
                  settings: {
                    slidesToShow: 8,
                    slidesToScroll: 8,
                    dots: false,
                    arrows: false
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                }
              ]
            });
          }
        }
      }
    }
    function loadSlickBlockBannerBelowAutomotive (tScroll){
      let selector = ".block-banner-below-automotive .container";
      const $blockBannerAutomotive = $(selector);
      if ($blockBannerAutomotive.length) {
        const $blockBannerAutomotiveTop = $blockBannerAutomotive.offset().top - screen.height;
        if (tScroll > $blockBannerAutomotiveTop && check_BlockBannerBelowDevice) {
          check_BlockBannerBelowDevice = false;
          if(screen.width <=1024){
            $blockBannerAutomotive.slick({
              dots: true,
              arrows: false,
              infinite: true,
              mobileFirst: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              responsive: [
                {
                  breakpoint: 1025,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: false,
                    arrows: false
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                }
              ]
            });
          }
        }
      }
    }
    function loadSlickBlockBannerTopCategory (tScroll){
      let selector = ".home-block-top-category .container .block-content:not(.service)";
      const $blockBannerTopCategory = $(selector);
      if ($blockBannerTopCategory.length) {
        const $blockBannerTopCategoryTop = $blockBannerTopCategory.offset().top - screen.height;
        if (tScroll > $blockBannerTopCategoryTop && check_BlockBannerTopCategory) {
          check_BlockBannerTopCategory = false;
          if (screen.width <= 1024) {
            $blockBannerTopCategory.slick({
              dots: true,
              arrows: false,
              infinite: true,
              mobileFirst: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              responsive: [
                {
                  breakpoint: 1025,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: false,
                    arrows: false
                  },
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                }
              ]
            });
          }
           
        }
      }
    }
    function loadSlickBlockBannerProductWithBanner (tScroll){
      let selector = ".block-image-below-cate .container";
      const $blockBannerProductWithBanner = $(selector);
      if ($blockBannerProductWithBanner.length) {
        const $blockBannerProductWithBannerTop = $blockBannerProductWithBanner.offset().top - screen.height;
        if (tScroll > $blockBannerProductWithBannerTop && check_BlockBannerProductWithBanner) {
          check_BlockBannerProductWithBanner = false;
          if (screen.width <= 1024) {
            setTimeout(()=>{
              $blockBannerProductWithBanner.slick({
                dots: true,
                arrows: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [
                  {
                    breakpoint: 1025,
                    settings: {
                      slidesToShow:2,
                      slidesToScroll: 2,
                      dots: false,
                      arrows: false
                    },
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  }
                ]
              });
            },100);
            
          }
           
        }
      }
    }
    function activeTabBlockWithCate(selector, numSlide) {
      loadProductWithCate(selector, numSlide);
      document
        .querySelectorAll(selector + " .list-categories [data-tab]")
        .forEach((item) => {
          item.addEventListener("click", (e) => {
            loadProductWithCate(selector, numSlide);
          });
        });
    }
    function loadProductWithCate(selector, numSlide) {
      const options = {
        template: "products/carousel-3",
      };

      if ($(selector).length > 0) {
        if (
          !$(
            selector +
              " .section-product-with-cate.is-active .productCarousel .productCarousel-slide"
          ).length
        ) {
          var block = $(selector + " .section-product-with-cate.is-active"),
            wrap = block.find(".productCarousel"),
            catId = block.data("tab-category-id"),
            catUrl = block.data("tab-category-url"),
            blockId = block.attr("id");

          if (
            !$(selector + " .section-product-with-cate.is-active")
              .find(".productCarousel")
              .hasClass("slick-initialized")
          ) {
            block.find(".loadingOverlay").show();
            loadCategory(catId, catUrl, options, wrap, blockId, numSlide);
          }
        }
      }

      function loadCategory(id, url, option, wrap, blockId, numSlide) {
        utils.api.getPage(url, option, (err, response) => {
          if (!wrap.find(".productCarousel-slide").length) {
            wrap.html(response);
            slickCarousel(wrap, numSlide);
            wrap
              .parents(".section-product-with-cate")
              .find(".loadingOverlay")
              .remove();

            haloAddOptionForProduct(context, blockId);
          }
        });
      }

      function slickCarousel(wrap, numSlide) {
        wrap.slick({
          dots: true,
          arrows: false,
          infinite: false,
          mobileFirst: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                arrows: true,
                slidesToShow: numSlide ,
                slidesToScroll: numSlide
              },
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: numSlide - 1,
                slidesToScroll: numSlide - 1
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: numSlide - 2,
                slidesToScroll: numSlide - 2
              }
            },
            {
              breakpoint: 551,
              settings: {
                slidesToShow: numSlide - 2,
                slidesToScroll: numSlide - 2
              }
            }

          ]
        });
      }
    }

    function loadTabBarFunction(tScroll) {
      let selector = ".categories-block .container";
      const $tabBar = $(selector);
      if ($tabBar.length) {
        const $tabBarTop = $tabBar.offset().top - screen.height;
        if (tScroll > $tabBarTop && loadTabBar) {
          loadTabBar = false;
          let tabBars = document.querySelectorAll(selector);
          if (tabBars) {
            tabBars.forEach((container) => {
              let listTabBar = container.querySelectorAll(".list-type li");
              let listBlockBar = container.querySelectorAll("[data-link]");
              let activeTab = container.querySelector(
                ".list-type li.is-active"
              );
              let firstTab = container.querySelector(
                ".list-type li:first-child"
              );
              if (activeTab) {
                let blockNameTab = activeTab.getAttribute("data-tab");
                let blockItem = container.querySelector(
                  `[data-link="${blockNameTab}"]`
                );
                blockItem.classList.add("is-active");
              } else {
                firstTab.classList.add("is-active");
                let tabFirst = firstTab.getAttribute("data-tab");
                let blockFirstItem = container.querySelector(
                  `[data-link="${tabFirst}"]`
                );
                blockFirstItem.classList.add("is-active");
              }
              listTabBar.forEach((item) => {
                item.onclick = (e) => {
                  e.preventDefault();
                  let blockName = item.getAttribute("data-tab");
                  item.classList.add("is-active");

                  listTabBar.forEach((tab) => {
                    if (tab.getAttribute("data-tab") == blockName) {
                      tab.classList.add("is-active");
                    } else {
                      tab.classList.remove("is-active");
                    }
                  });
                  listBlockBar.forEach((block) => {
                    if (block.getAttribute("data-link") == blockName) {
                      block.classList.add("is-active");
                    } else {
                      block.classList.remove("is-active");
                    }
                  });
                };
              });
            });
          }
        }
      }
    }
  }
  function createCarouselBannerReviewCustomer(tScroll) {
    let selector = ".halo-block-slides";
    const $carouselCarouselBannerReviewCustomer = $(selector);
    if ($carouselCarouselBannerReviewCustomer.length) {
      const $carouselCarouselBannerReviewCustomerTop =
        $carouselCarouselBannerReviewCustomer.offset().top - screen.height - 50;
      if (
        tScroll > $carouselCarouselBannerReviewCustomerTop &&
        check_carouselBannerReviewCustomer
      ) {
        check_carouselBannerReviewCustomer = false;
        $(selector).slick({
          dots: true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 4000,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false
              },
            },
            {
              breakpoint: 551,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                autoplaySpeed: 7000
              },
            },
            {
              breakpoint: 10,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false
              }
            }
          ]
        });
      }
    }
  }
  function addLinkBanner(){
    let listBannerLink = document.querySelectorAll("[data-href]");
    listBannerLink.forEach((item) => {
      item.onclick = () => {
        window.location.href = item.getAttribute("data-href");
      };
    });
    
  }

  build();
}
